import clsx from 'clsx';
import React, { useLayoutEffect, useState } from 'react';
import {fromEvent, timer} from "rxjs";
import {filter} from "rxjs/operators";

import CloseSvg from "#app/assets/icons/close.svg";
import {FullsizeImageContainer, FullsizeImageWrapper} from "#app/components/layout/GridContainer/styles";

const FullscreenImageContainer = () => {
    const [
        fullSizeImagePath,
        setFullSizeImagePath
    ] = useState<string | null>(null);
    const [opacityEnabled, setOpacityEnabled] = useState<boolean>(false);
    const [zoomed, setZoomed] = useState<boolean>(false);

    const quitFullSizeView = () => {
        setOpacityEnabled(false);
        setZoomed(false);
        timer(200).subscribe(() => {
            localStorage.removeItem("fullsize_image_path");
            setFullSizeImagePath(null);
        });
    };

    const openFullsizeView = () => {
        const imagePath: string | null = localStorage.getItem("fullsize_image_path");
        if (imagePath) {
            setFullSizeImagePath(imagePath);
        }
        timer(10).subscribe(() => setOpacityEnabled(true));
    };

    useLayoutEffect(() => {
        const keyupSubscription = fromEvent<KeyboardEvent>(window, "keyup")
            .pipe(
                filter((event) => event.code === "Escape")
            ).subscribe(
                () => {
                    quitFullSizeView();
                }
            );

        const openSubscription = fromEvent(
            window,
            "fullsizeImageOpen"
        ).subscribe(() => {
            openFullsizeView();
        });

        return () => {
            keyupSubscription.unsubscribe();
            openSubscription.unsubscribe();
        };
    }, []);

    return (
        <>
            {fullSizeImagePath && (
                <FullsizeImageContainer className={clsx({[`enabled`]: opacityEnabled})}>
                    <button onClick={quitFullSizeView}>
                        <img src={CloseSvg} alt={``}/>
                    </button>
                    <FullsizeImageWrapper>
                        <img
                            className={clsx({['zoomed']: zoomed, ['enabled']: opacityEnabled})}
                            onClick={() => setZoomed(!zoomed)}
                            src={fullSizeImagePath}
                            alt={``}
                        />
                    </FullsizeImageWrapper>
                </FullsizeImageContainer>
            )}
        </>
    );
}

export default FullscreenImageContainer;